/**
 * Names an address for pickers, lists and cards. The title is optional, so
 * an address without one is named after where it is: "Kerkstraat 12, Gent".
 *
 * Returns '' for a missing address, and the generic "Address" label when
 * neither a title nor a street or city was filled in.
 *
 * @param {?{title?: ?string, street?: ?string, number?: ?string, city?: ?string}} location
 * @returns {string}
 */
export function locationLabel(location) {
    if (!location) {
        return '';
    }

    const title = (location.title || '').trim();
    if (title) {
        return title;
    }

    const streetLine = [location.street, location.number]
        .map((part) => (part || '').toString().trim())
        .filter(Boolean)
        .join(' ');
    const where = [streetLine, (location.city || '').trim()].filter(Boolean).join(', ');

    return where || trans('Address');
}
